var map = {
  "./": [
    "100",
    "25",
    "930",
    "705",
    "469"
  ],
  "./MoscowRoads.tsx": [
    "5345",
    "930"
  ],
  "./index.ts": [
    "100",
    "25",
    "930",
    "705",
    "469"
  ],
  "./SpbRoads.tsx": [
    "9064",
    "25"
  ],
  "./RostovRoads": [
    "7264",
    "705"
  ],
  "./index": [
    "100",
    "25",
    "930",
    "705",
    "469"
  ],
  "./RostovRoads.tsx": [
    "7264",
    "705"
  ],
  "./SpbRoads": [
    "9064",
    "25"
  ],
  "./MoscowRoads": [
    "5345",
    "930"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 1108;
module.exports = __rspack_async_context;
